export default "__VITE_ASSET__d5b43be0__"